"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GENERAL = void 0;
var GENERAL = {
  BUTTON__LOG_OFFLINE_ORDER: 'orders-button-logOfflineOrder',
  BUTTON__EXISTING_SUPPLIER: 'orders-div-ExistingSupplier',
  BUTTON__NEW_SUPPLIER: 'orders-div-NewSupplier',
  BUTTON__EXPORT_ORDERS: 'orders-div-exportOrders',
  BUTTON_FILTERS: 'orders-div-filters',
  BUTTON__NEEDS_APPROVAL_BANNER: 'orders-button-viewNeedsApprovalOrders',
  INPUT__FILTER_SEARCH: 'ordersFilters-input-search',
  BUTTON__DELIVERY_DATE: 'ordersFilters-button-deliveryDate',
  TEXTAREA__DISPUTE_ORDER_NOTE: 'ordersDisputeOrderModal-textarea-note',
  TEXT__INVOICE_NUMBER_REMAINING: 'orders-span-pendingInvoicesRemaining',
  TEXT__INVOICE_NUMBER_TOTAL: 'orders-span-pendingInvoicesLimit',
  LINK__ORDER_HISTORY: 'ordersNavigation-a-orderHistory',
  LINK__PENDING_UPDATES: 'ordersNavigation-a-pendingUpdates',
  LINK__STANDING_ORDERS: 'ordersNavigation-a-standingOrders'
};
exports.GENERAL = GENERAL;